export const SecondLevelShareByRegion = {
    "selectedValueColumn": "RegionCode",
    "visuals": [
        {
            "title": "Region",
            "visual": [
                {
                    "columns": 6,
                    "rows": 1,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme2',
                        "title": "Actual vs Target (% Performance)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Target',
                                        "value": 'TargetSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Performance %',
                                        "value": 'Performance',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "RegionCode",
                                "endpoint": "N30.1",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 6,
                    "rows": 1,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme1',
                        "title": "Actual Sales vs Last Year (% Growth)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "value": 'LYSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Growth %',
                                        "value": 'Growth',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "RegionCode",
                                "endpoint": "N30.1",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }

                },
                {
                    "columns": 6,
                    "rows": 1,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme2',
                        "title": "Comparative Monthly (Actual Vs. Target)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Target',
                                        "value": 'TargetSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Performance %',
                                        "value": 'Performance',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "Month",
                                "endpoint": "N30.4",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 6,
                    "rows": 1,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme1',
                        "title": "Comparative Monthly (Last Year vs Actual Sales)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "value": 'LYSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Growth %',
                                        "value": 'Growth',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "Month",
                                "endpoint": "N30.5",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "District",
            "visual": [
                {
                    "columns": 6,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme2',
                        "title": "Actual vs Target (% Performance)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Target',
                                        "value": 'TargetSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Performance %',
                                        "value": 'Performance',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "DistrictManagerName",
                                "endpoint": "N30.2",
                                "filter": {
                                    "show": false,
                                    "local": ["DistrictManagerName"],
                                },
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "DistrictManagerName", "value": '' },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                        "selectedValueColumn": "RegionCodeDistrictManagerName",
                                        "selectedTitle": "Comparative Monthly Performance",
                                        "visual": [
                                            {
                                                "columns": 12,
                                                "rows": 2,
                                                "visual": {
                                                    "id": 1,
                                                    "type": "combo",
                                                    "colorTheme": 'colorTheme2',
                                                    "title": "Actual vs Target (% Performance)",
                                                    "orientation": "vertical",
                                                    "xAxis": "",
                                                    "yAxis": "",
                                                    "binding": {
                                                        "data": {
                                                            "series": [
                                                                {
                                                                    "name": 'Sales',
                                                                    "value": 'ActualSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Target',
                                                                    "value": 'TargetSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Performance %',
                                                                    "value": 'Performance',
                                                                    "type": 'line',
                                                                    "percent": true
                                                                }
                                                            ],
                                                            "title": "Month",
                                                            "endpoint": "N30.6",
                                                            "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "RegionCodeDistrictManagerName", "value": '' },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                            ]
                                                        },
                                                        "context": {
                                                            "point": {
                                                                "onClick": {

                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 6,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme1',
                        "title": "Actual Sales vs Last Year (% Growth)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "value": 'LYSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Growth %',
                                        "value": 'Growth',
                                        "type": 'line',
                                        "percent": true
                                    }

                                ],
                                "title": "DistrictManagerName",
                                "endpoint": "N30.2",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "DistrictManagerName", "value": '' },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                        "selectedValueColumn": "RegionCodeDistrictManagerName",
                                        "selectedTitle": "Comparative Monthly Growth",
                                        "visual": [
                                            {
                                                "columns": 12,
                                                "rows": 2,
                                                "visual": {
                                                    "id": 1,
                                                    "type": "combo",
                                                    "colorTheme": 'colorTheme2',
                                                    "title": "% Growth ( This Year Vs Last Year )",
                                                    "xAxis": "",
                                                    "yAxis": "",
                                                    "binding": {
                                                        "data": {
                                                            "series": [
                                                                {
                                                                    "name": 'Sales',
                                                                    "value": 'ActualSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'LY Sales',
                                                                    "value": 'LYSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Growth %',
                                                                    "value": 'Growth',
                                                                    "type": 'line',
                                                                    "percent": true
                                                                }
                                                            ],
                                                            "title": "Month",
                                                            "endpoint": "N30.7",
                                                            "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "RegionCodeDistrictManagerName", "value": '' },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                            ]
                                                        },
                                                        "context": {
                                                            "point": {
                                                                "onClick": {

                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }

                }
            ]
        },
        {
            "title": "PMR",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme2',
                        "title": "Actual vs Target (% Performance)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Target',
                                        "value": 'TargetSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Performance %',
                                        "value": 'Performance',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "AgentName",
                                "endpoint": "N30.3",
                                "filter": {
                                    "show": false,
                                    "local": ["AgentName"],
                                },
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "AgentName", "value": '' },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                        "selectedValueColumn": "RegionCodeAgentName",
                                        "selectedTitle": "Comparative Monthly Performance",
                                        "visual": [
                                            {
                                                "columns": 12,
                                                "rows": 1,
                                                "visual": {
                                                    "id": 1,
                                                    "type": "combo",
                                                    "colorTheme": 'colorTheme2',
                                                    "title": "Actual vs Target (% Performance)",
                                                    "orientation": "vertical",
                                                    "xAxis": "",
                                                    "yAxis": "",
                                                    "binding": {
                                                        "data": {
                                                            "series": [
                                                                {
                                                                    "name": 'Sales',
                                                                    "value": 'ActualSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Target',
                                                                    "value": 'TargetSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Performance %',
                                                                    "value": 'Performance',
                                                                    "type": 'line',
                                                                    "percent": true
                                                                }
                                                            ],
                                                            "title": "Month",
                                                            "endpoint": "N30.8",
                                                            "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "RegionCodeAgentName", "value": '' },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                            ]
                                                        },
                                                        "context": {
                                                            "point": {
                                                                "onClick": {

                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme1',
                        "title": "Actual Sales vs Last Year (% Growth)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'ActualSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "value": 'LYSales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Growth %',
                                        "value": 'Growth',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "AgentName",
                                "endpoint": "N30.3",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "RegionCode", "value": "" },
                                    { "key": "AgentName", "value": '' },
                                    { "key": "ConfigTypeCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                        "selectedValueColumn": "RegionCodeAgentName",
                                        "selectedTitle": "Comparative Monthly Growth",
                                        "visual": [
                                            {
                                                "columns": 6,
                                                "rows": 1,
                                                "visual": {
                                                    "id": 1,
                                                    "type": "combo",
                                                    "colorTheme": 'colorTheme1',
                                                    "title": "This Year vs Last Year (% Growth)",
                                                    "orientation": "vertical",
                                                    "xAxis": "",
                                                    "yAxis": "",
                                                    "binding": {
                                                        "data": {
                                                            "series": [
                                                                {
                                                                    "name": 'Sales',
                                                                    "value": 'ActualSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'LY Sales',
                                                                    "value": 'LYSales',
                                                                    "type": 'column'
                                                                },
                                                                {
                                                                    "name": 'Growth %',
                                                                    "value": 'Growth',
                                                                    "type": 'line'
                                                                }
                                                            ],
                                                            "title": "Month",
                                                            "endpoint": "N30.9",
                                                            "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "RegionCodeAgentName", "value": '' },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                            ]
                                                        },
                                                        "context": {
                                                            "point": {
                                                                "onClick": {

                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            ]
        }
    ]
}